class ServicesShowcaseBlock {
  constructor() {
    this.sections = Array.from(document.querySelectorAll(".services-showcase"));
    if (!this.sections.length) return;

    this.sections.forEach((section, index) => this.initSection(section, index));
  }

  initSection(section, sectionIndex) {
    const inner = section.querySelector(".services-showcase__inner") || section;
    const track = section.querySelector(".services-showcase__track");
    if (!track) return;

    this.markCards(track);
    const controls = this.ensureControls(inner, sectionIndex);
    if (!controls) return;

    const prevBtn = controls.querySelector(".services-showcase__arrow--prev");
    const nextBtn = controls.querySelector(".services-showcase__arrow--next");
    if (!prevBtn || !nextBtn) return;

    const getStep = () => {
      const firstCard = track.querySelector(".services-showcase__card");
      if (!firstCard) return 320;
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || "0") || 0;
      return firstCard.getBoundingClientRect().width + gap;
    };

    const updateControls = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft >= maxScroll - 4;

      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
      prevBtn.setAttribute("aria-disabled", atStart ? "true" : "false");
      nextBtn.setAttribute("aria-disabled", atEnd ? "true" : "false");
    };

    prevBtn.addEventListener("click", () => {
      track.scrollBy({ left: -getStep(), behavior: "smooth" });
    });

    nextBtn.addEventListener("click", () => {
      track.scrollBy({ left: getStep(), behavior: "smooth" });
    });

    track.addEventListener("scroll", updateControls);
    window.addEventListener("resize", updateControls);
    updateControls();
  }

  markCards(track) {
    const cards = Array.from(track.children).filter((item) => item.nodeType === 1);
    cards.forEach((card) => {
      card.classList.add("services-showcase__card");

      const directChildren = Array.from(card.children).filter((item) => item.nodeType === 1);
      const contentWrap = directChildren.find(
          (child) => !child.classList.contains("wp-block-image")
      );

      if (contentWrap) {
        contentWrap.classList.add("services-showcase__card-content");
      }

      const image = card.querySelector(".wp-block-image img");
      if (image) this.upgradeCardImageQuality(image);
    });
  }

  upgradeCardImageQuality(image) {
    const srcset = image.getAttribute("srcset");
    if (!srcset) return;

    const candidates = srcset
        .split(",")
        .map((entry) => {
          const parts = entry.trim().split(/\s+/);
          if (parts.length < 2) return null;
          const widthMatch = parts[1].match(/^(\d+)w$/);
          if (!widthMatch) return null;
          return { url: parts[0], width: Number(widthMatch[1]) };
        })
        .filter(Boolean);

    if (!candidates.length) return;

    const largest = candidates.reduce((prev, current) =>
        current.width > prev.width ? current : prev
    );

    // Ensure browser picks an appropriately large source for card rendering.
    image.setAttribute("sizes", "(max-width: 781px) 78vw, (max-width: 1200px) 44vw, 22vw");
    if (largest && largest.url) {
      image.setAttribute("src", largest.url);
    }
  }

  ensureControls(inner, sectionIndex) {
    let controls = inner.querySelector(".services-showcase__controls");
    if (controls) return controls;

    controls = document.createElement("div");
    controls.className = "services-showcase__controls";

    const prevBtn = document.createElement("button");
    prevBtn.type = "button";
    prevBtn.className = "services-showcase__arrow services-showcase__arrow--prev";
    prevBtn.setAttribute("aria-label", "Previous services");
    prevBtn.setAttribute("aria-controls", `services-showcase-track-${sectionIndex + 1}`);
    prevBtn.innerHTML = "&#10094;";

    const nextBtn = document.createElement("button");
    nextBtn.type = "button";
    nextBtn.className = "services-showcase__arrow services-showcase__arrow--next";
    nextBtn.setAttribute("aria-label", "Next services");
    nextBtn.setAttribute("aria-controls", `services-showcase-track-${sectionIndex + 1}`);
    nextBtn.innerHTML = "&#10095;";

    controls.append(prevBtn, nextBtn);

    const track = inner.querySelector(".services-showcase__track");
    if (track && !track.id) {
      track.id = `services-showcase-track-${sectionIndex + 1}`;
    }
    inner.appendChild(controls);
    return controls;
  }
}

export default ServicesShowcaseBlock;
